const styles = {
  container: {},
  label: { fontWeight: 400, fontSize: '14px', color: '#1A1A1A', paddingBottom: '6px' },
};
export default styles;
